import * as React from 'react';
import type { WrappedComponentProps } from 'react-intl-next';
import { injectIntl } from 'react-intl-next';
import { withErrorPage } from 'view/common/error-page';
import { RequestFeedbackStateless } from '../request-feedback-stateless';

interface RequestFeedbackInitialStateWrapperProps {
    isLoading: boolean;
    rating: number;
    commentSubmitting: boolean;
    commentSubmitted: boolean;
    validationErrorType?: string;
    onRatingChange: (rating: number) => void;
    onSaveComment: (comment: string) => void;
    onErrorFlagDismiss: () => void;
    redirectToLogin: boolean;
}

export class RequestFeedbackInitialStateWrapper extends React.Component<
    RequestFeedbackInitialStateWrapperProps & WrappedComponentProps
> {
    render() {
        const {
            isLoading,
            rating,
            onRatingChange,
            onSaveComment,
            commentSubmitting,
            commentSubmitted,
            validationErrorType,
            onErrorFlagDismiss,
            redirectToLogin,
        } = this.props;

        return (
            <RequestFeedbackStateless
                isLoading={isLoading}
                rating={rating}
                onRatingChange={onRatingChange}
                onSaveComment={onSaveComment}
                commentSubmitting={commentSubmitting}
                commentSubmitted={commentSubmitted}
                validationErrorType={validationErrorType}
                onErrorFlagDismiss={onErrorFlagDismiss}
                redirectToLogin={redirectToLogin}
            />
        );
    }
}

export default withErrorPage(injectIntl(RequestFeedbackInitialStateWrapper));
